import { CSS, styled } from "@givenwell/stitches";
import { colors, easing } from "@givenwell/theme";
import { ComponentPropsWithRef, ForwardedRef, forwardRef, useContext } from "react";
import { FieldContext } from "./Field";

export type SelectFieldProps = Omit<ComponentPropsWithRef<"select">, "size"> & {
  css?: CSS;
  invalid?: boolean;
  label?: string;
  onValueChange?: (value: string) => void;
};

export const SelectField = forwardRef(function TextField(
  { invalid, onValueChange, css, label, ...props }: SelectFieldProps,
  ref: ForwardedRef<HTMLSelectElement>,
) {
  const { inputProps } = useContext(FieldContext);
  return (
    <Root css={css}>
      <FloatingLabel floating>{label}</FloatingLabel>
      <StyledInput
        {...inputProps}
        // invalid={invalid}
        {...props}
        ref={ref}
        onChange={e => {
          props.onChange?.(e);
          onValueChange?.(e.target.value);
        }}
      />
    </Root>
  );
});

const Root = styled("div", {
  pos: "relative",
  w: "100%",
  height: 56,
});
const StyledInput = styled("select", {
  minW: 0,
  w: "100%",
  height: "100%",
  px: 16,
  pt: 16,
  "&::placeholder": {
    color: colors.text3,
  },
  textAlign: "inherit",

  caretColor: colors.text,
  backgroundColor: colors.warmGreyHalf,
  borderRadius: 9,
  "&:focus": {
    outline: "none",
    borderColor: colors.blue500,
    boxShadow: `0 0 0 1px ${colors.blue500}`,
  },
});

const FloatingLabel = styled("label", {
  position: "absolute",
  top: 8,
  lineHeight: 1,
  left: 16,
  fontScale: "md",
  pointerEvents: "none",
  color: colors.text2,

  transition: `all 200ms ${easing.standard}`,
  transformOrigin: "top left",
  willChange: "transform",

  variants: {
    floating: {
      false: {
        top: "50%",
        transform: "translateY(-50%)",
        fontScale: "md",
        lineHeight: "16px",
      },
      true: {
        top: 8,
        transform: "translateY(0%)",
        fontScale: "xs",
        lineHeight: "16px",
      },
    },
  },
});
